const FAQIconSvg = ({
  width = 15,
  height = 17,
  viewBox = '0 0 15 17',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox}>
      <path
        d="M6.75 16.9425V14.2425C2.9925 14.0475 0 10.9275 0 7.125C0 3.195 3.195 0 7.125 0C11.055 0 14.25 3.195 14.25 7.125C14.25 10.8375 11.67 14.5725 7.8225 16.425L6.75 16.9425ZM7.125 1.5C4.02 1.5 1.5 4.02 1.5 7.125C1.5 10.23 4.02 12.75 7.125 12.75H8.25V14.475C10.98 12.75 12.75 9.915 12.75 7.125C12.75 4.02 10.23 1.5 7.125 1.5ZM6.375 10.125H7.875V11.625H6.375V10.125ZM7.875 9H6.375C6.375 6.5625 8.625 6.75 8.625 5.25C8.625 4.425 7.95 3.75 7.125 3.75C6.3 3.75 5.625 4.425 5.625 5.25H4.125C4.125 3.5925 5.4675 2.25 7.125 2.25C8.7825 2.25 10.125 3.5925 10.125 5.25C10.125 7.125 7.875 7.3125 7.875 9Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default FAQIconSvg;
